export default class BeneficiarioOcorrencia {
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.beneficiarioId = 0;
        this.beneficiario = null;
        this.projetoId = null;
        this.projeto = null;
        this.ocorrenciaTipoId = 0;
        this.ocorrenciaTipo = null;
        this.dataOcorrencia = new Date().yyyymmdd();
        this.descricao = '';
        this.observacoes = '';
        this.gravidade = '';
        this.gravidadeStr = '';
        this.usuarioId = 0;
        this.usuario = null;
        this.anexo = '';

        if (!model)
            return;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId ? model.empresaId : 0;
        this.beneficiarioId = model.beneficiarioId;
        this.beneficiario = model.beneficiario;
        this.projetoId = model.projetoId ? model.projetoId : null;
        this.projeto = model.projeto;
        this.ocorrenciaTipoId = model.ocorrenciaTipoId;
        this.ocorrenciaTipo = model.ocorrenciaTipo;
        this.dataOcorrencia = model.dataOcorrencia ? new Date(model.dataOcorrencia).yyyymmdd() : new Date().yyyymmdd();
        this.descricao = model.descricao;
        this.observacoes = model.observacoes;
        this.gravidade = model.gravidade;
        this.gravidadeStr = model.gravidadeStr;
        this.usuarioId = model.usuarioId;
        this.usuario = model.usuario;
        this.anexo = model.anexo;

        if (model.createdAt)
            this.createdAt = model.createdAt;
        if (model.updatedAt)
            this.updatedAt = model.updatedAt;
    }
}
